import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const SendIcon = ({
  width = 24,
  height = 24,
  stroke = '#fff',
  fill = 'none',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z"
    />
  </svg>
);
